<div class="app">
  @if (!store.loading()) {
  <todos-list />
  } @else {
  <mat-spinner></mat-spinner>
  }
</div>